import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";
import BackgroundCover from '../../../components/backgroundCover/BackgroundCover';
import { isMobile } from '../../../utils/appUtils';
import ImageWithFallback from "../../../components/imageWithFalback";
import { Link } from 'react-router-dom';

import '../../styling.css';

const Innovations: React.FC = () => {
  const [markdownContent, setMarkdownContent] = useState('');
  const imagePrefix = "innovations";
  const fadeDuration = 2000;

  useEffect(() => {
    const fetchMarkdownContent = async () => {
      try {
        const response = await fetch('/innovations.md');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("text/html") !== -1) {
          throw new Error("Received HTML instead of Markdown");
        }
        const text = await response.text();
        console.log("Fetched markdown content:", text); // Debug log
        setMarkdownContent(text);
      } catch (error) {
        console.error('Error fetching markdown:', error);
        setMarkdownContent('Failed to load content. Please try again later.');
      }
    };

    fetchMarkdownContent();
  }, []);

  const getSection = (sectionName: string): string => {
    const sectionRegex = new RegExp(`## ${sectionName}([\\s\\S]*?)(?=## |$)`, 'i');
    const match = markdownContent.match(sectionRegex);
    return match ? match[1].trim() : '';
  };

  const getSectionParagraphs = (sectionName: string): string[] => {
    const sectionRegex = new RegExp(`## ${sectionName}([\\s\\S]*?)(?=## |$)`, 'i');
    const match = markdownContent.match(sectionRegex);
    
    if (match) {
      const sectionContent = match[1].trim();
      return sectionContent.split(/\n\s*\n|\r?\n(?!\s*\n)/).filter(p => p);
    }
    
    return [];
  };

  const subPanel1Paragraphs = getSectionParagraphs('Sub Panel 1 - Content');
  const subPanel2Paragraphs = getSectionParagraphs('Sub Panel 2 - Content');
  const subPanel3Paragraphs = getSectionParagraphs('Sub Panel 3 - Content');
  const subPanel4Paragraphs = getSectionParagraphs('Sub Panel 4 - Content');
  const subPanel5Paragraphs = getSectionParagraphs('Sub Panel 5 - Content');

  const renderContent = () => {
    if (isMobile()) {
      return (
        <>
          <Fade duration={fadeDuration}>
            <h1 className="main-title">{getSection('Header')}</h1>
            <p className="main-content-title">{getSection('Main Title')}</p>
            <div className="main-content">
              <div className="sub-text-wrapper">
                <div className="">{getSection('Main content - Left')}</div>
                <div className="">{getSection('Main content - Right')}</div>
              </div>
            </div>
          </Fade>
          
          <Fade duration={fadeDuration}>
            <ImageWithFallback src={`/images/${imagePrefix}_main.jpg`} alt="Main Innovations" className="page-image-main" />
          </Fade>

          <Fade duration={fadeDuration}>
            <div className="sub-content">
              <ImageWithFallback src={`/images/${imagePrefix}_sub1.jpg`} alt="Sub Panel 1" className="sub-image" />
              <div className="sub-left">
                <div className="sub-text-wrapper">
                  <p className="title">{getSection('Sub Panel 1 - Title')}</p>
                  {subPanel1Paragraphs.map((paragraph: string, index: number) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </Fade>

          <Fade duration={fadeDuration}>
            <div className="sub-content">
              <ImageWithFallback src={`/images/${imagePrefix}_sub2.jpg`} alt="Sub Panel 2" className="sub-image-right" />
              <div className="sub-left-right">
                <div className="sub-text-wrapper">
                  <p className="title">{getSection('Sub Panel 2 - Title')}</p>
                  {subPanel2Paragraphs.map((paragraph: string, index: number) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </Fade>

          <Fade duration={fadeDuration}>
            <div className="sub-content">
              <ImageWithFallback src={`/images/${imagePrefix}_sub3.jpg`} alt="Sub Panel 3" className="sub-image" />
              <div className="sub-left">
                <div className="sub-text-wrapper">
                  <p className="title">{getSection('Sub Panel 3 - Title')}</p>
                  {subPanel3Paragraphs.map((paragraph: string, index: number) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </Fade>

          <Fade duration={fadeDuration}>
            <div className="sub-content">
              <ImageWithFallback src={`/images/${imagePrefix}_sub4.jpg`} alt="Sub Panel 4" className="sub-image-right" />
              <div className="sub-left-right">
                <div className="sub-text-wrapper">
                  <p className="title">{getSection('Sub Panel 4 - Title')}</p>
                  {subPanel4Paragraphs.map((paragraph: string, index: number) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </Fade>

          <Fade duration={fadeDuration}>
            <div className="sub-content-last">
              <ImageWithFallback src={`/images/${imagePrefix}_sub5.jpg`} alt="Sub Panel 5" className="sub-image" />
              <div className="sub-left">
                <div className="sub-text-wrapper">
                  <p className="title">{getSection('Sub Panel 5 - Title')}</p>
                  {subPanel5Paragraphs.map((paragraph: string, index: number) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                  <div className="main-right">Die introspective ist eine uhr für diejenigen, die in ihrem alltag die faszination an dem, was hinter der oberfläche. <Link to="/maison/patents" style={{ color: 'inherit' }}><strong><u>Discover more.</u></strong></Link></div>
                </div>
              </div>
            </div>
          </Fade>
        </>
      );
    } else {
      return (
        <>
          <Fade duration={fadeDuration}>
            <h1 className="main-title">{getSection('Header')}</h1>
            <p className="main-content-title">{getSection('Main Title')}</p>
            <div className="main-content">
              <div className="main-left">{getSection('Main content - Left')}</div>
              <div className="main-right">{getSection('Main content - Right')}</div>
            </div>
          </Fade>
          
          <Fade duration={fadeDuration}>
            <div className="page-image-main">
              <ImageWithFallback src={`/images/${imagePrefix}_main.jpg`} alt="Main Innovations" className="px-4" />
            </div>
          </Fade>

          <Fade duration={fadeDuration}>
            <div className="sub-content">
              <div className="sub-left">
                <div className="sub-text-wrapper">
                  <p className="title">{getSection('Sub Panel 1 - Title')}</p>
                  {subPanel1Paragraphs.map((paragraph: string, index: number) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>
              <ImageWithFallback src={`/images/${imagePrefix}_sub1.jpg`} alt="Sub Panel 1" className="sub-image" />
            </div>
          </Fade>

          <Fade duration={fadeDuration}>
            <div className="sub-content">
              <ImageWithFallback src={`/images/${imagePrefix}_sub2.jpg`} alt="Sub Panel 2" className="sub-image-right" />
              <div className="sub-left-right">
                <div className="sub-text-wrapper">
                  <p className="title">{getSection('Sub Panel 2 - Title')}</p>
                  {subPanel2Paragraphs.map((paragraph: string, index: number) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </Fade>

          <Fade duration={fadeDuration}>
            <div className="sub-content">
              <div className="sub-left">
                <div className="sub-text-wrapper">
                  <p className="title">{getSection('Sub Panel 3 - Title')}</p>
                  {subPanel3Paragraphs.map((paragraph: string, index: number) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>
              <ImageWithFallback src={`/images/${imagePrefix}_sub3.jpg`} alt="Sub Panel 3" className="sub-image" />
            </div>
          </Fade>

          <Fade duration={fadeDuration}>
            <div className="sub-content">
              <ImageWithFallback src={`/images/${imagePrefix}_sub4.jpg`} alt="Sub Panel 4" className="sub-image-right" />
              <div className="sub-left-right">
                <div className="sub-text-wrapper">
                  <p className="title">{getSection('Sub Panel 4 - Title')}</p>
                  {subPanel4Paragraphs.map((paragraph: string, index: number) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </Fade>

          <Fade duration={fadeDuration}>
            <div className="sub-content-last">
              <div className="sub-left">
                <div className="sub-text-wrapper">
                  <p className="title">{getSection('Sub Panel 5 - Title')}</p>
                  {subPanel5Paragraphs.map((paragraph: string, index: number) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                  <div className="main-right">Die introspective ist eine uhr für diejenigen, die in ihrem alltag die faszination an dem, was hinter der oberfläche. <Link to="/maison/patents" style={{ color: 'inherit' }}><strong><u>Discover more.</u></strong></Link></div>
                </div>
              </div>
              <ImageWithFallback src={`/images/${imagePrefix}_sub5.jpg`} alt="Sub Panel 5" className="sub-image" />
            </div>
          </Fade>
        </>
      );
    }
  };

  return (
    <div className="page-container">
      <BackgroundCover
        backgroundHeight={300}
        imagePosition='initial'
        backgroundImage={`/images/${imagePrefix}_background.jpg`}
      />
      <div className="content">
        {renderContent()}
      </div>
    </div>
  );
};

export default Innovations;

